import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { withSignUp } from '../SignUpContext';
import { SignUpConfirmPhoneContent } from './SignUpConfirmPhoneContent';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { PageContainer } from '../../../components/page-container/PageContainer';
import { Page } from '../../../components/page/Page';
import styles from './sign_up_confirm_phone.module.scss';
import { SignUpLayout } from '../user/SignUpLayout';
import { Paper } from '../../../components/paper/Paper';

type Props = RouteComponentProps & {
  phoneNumber: string;
  source: string;
  sourcePage: string;
  isICP: boolean;
};

export class RawSignUpConfirmPhone extends React.Component<Props> {
  getToNextStep = ({ isDuplicateSignup }: { isDuplicateSignup: boolean }) => {
    const source = isDuplicateSignup ? '/?source=double_signup' : '/';
    this.props.history.push(source);
    window.location.reload();
  };

  tryOtherPhoneNumber = () => {
    doctrineAnalytics('Account SignUpChangePhone');
    const previousStepUrl = `/inscription/authentification${window.location.search}`;
    this.props.history.push(previousStepUrl);
  };

  render() {
    return (
      <SignUpLayout>
        <PageContainer classNames="signup-card">
          <Page classNames={styles.container}>
            <Paper level={0} className="signup-card__container center">
              <SignUpConfirmPhoneContent
                getToFirstStep={this.tryOtherPhoneNumber}
                getToNextStep={this.getToNextStep}
                phoneNumber={this.props.phoneNumber}
                source={this.props.source}
                sourcePage={this.props.sourcePage}
                isICP={this.props.isICP}
              />
            </Paper>
          </Page>
        </PageContainer>
      </SignUpLayout>
    );
  }
}

export const SignUpConfirmPhone = withSignUp(RawSignUpConfirmPhone);
